import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import Notiflix from "notiflix";

// ANT DESIGN IMPORTS
import {
  Input,
  Row,
  Typography,
  Card,
  Button,
  Modal,
  Form,
  Col,
  Table,
  Spin,
  Select,
  Divider,
  Tag,
  Tooltip,
} from "antd";

import {
  PlusCircleOutlined,
  EditOutlined,
  DeleteOutlined,
} from "@ant-design/icons";

// PROJECT IMPORTS
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import DownloadTableButtons from "../../../components/DownloadTableButtons";
import { rightAction } from "../../../redux/actions";
import { apiConfig, labelConfig, staticConfig } from "../configurations.config";
import styles from "../../../assets/styles/styles";

const { Text, Title } = Typography;

const DetailCode = (props) => {
  //DECLARED VARIABLES
  const { userData, rightBtn, rightAction } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state } = useLocation();

  const [isLoading, setIsLoading] = useState(true);
  const [selectedRow, setSelectedRow] = useState(null);
  const [tableCount, setTableCount] = useState("10");
  const [codeValues, setCodeValues] = useState([]);
  const [codeDetail, setCodeDetail] = useState({});
  const [originalList, setOriginalList] = useState([]);

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: "Description",
      dataIndex: "description",
      sorter: (a, b) => a["description"].localeCompare(b["description"]),
    },
    {
      title: "Position	",
      dataIndex: "position",
      sorter: (a, b) => a["position"].localeCompare(b["position"]),
    },
    {
      title: "Active?",
      dataIndex: "active",
      sorter: (a, b) => a["active"].localeCompare(b["active"]),
    },
    {
      title: "Action",
      render: (_, record) => (
        <>
          {BOM.HasPermission("UPDATE_CODEVALUE") && (
            <EditCodeValue
              currentCodeObj={state}
              userData={userData}
              codeObj={record}
              refreshList={getCodeList}
            />
          )}{" "}
          &nbsp;
          {BOM.HasPermission("DELETE_CODEVALUE") && (
            <Tooltip title={"Delete Code Value"}>
              <Button
                type="primary"
                shape="round"
                className="of-primaryBtnColor"
                onClick={() => handleOnDelete(record)}
              >
                <DeleteOutlined />
              </Button>
            </Tooltip>
          )}
        </>
      ),
    },
  ];

  useEffect(() => {
    getCodeDetail();
    getCodeList();
  }, []);

  const getCodeDetail = () => {
    const url = `${apiConfig.Codes}/${state.id}`;

    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        const objDetail = res;

        setCodeDetail(objDetail);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const getCodeList = () => {
    const url = `${apiConfig.Codes}/${state.id}/codevalues`;

    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        const objList = res;
        let tempCodeValues = [];

        objList.forEach((element) => {
          tempCodeValues.push({
            key: element?.id,
            id: element?.id,
            name: element?.name ? element?.name : "-",
            description: element?.description ? element?.description : "-",
            position:
              element?.position || element.position === 0
                ? element?.position
                : "-",
            active: element?.active ? "true" : "false",
          });
        });

        setCodeValues(tempCodeValues);
        setOriginalList(tempCodeValues);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };
  //DECLARED METHODS
  const onSelectItemAction = (selectedRowKeys, objParam) => {
    //HOLD THE OBJECT SELECTED HERE
    setSelectedRow(objParam[0]);
    [BOM.HasPermission("DELETE_CODEVALUE") && cnt.RIGHT_DELETE_BTN].map(
      (item) => {
        dispatch({
          type: item,
        });
      }
    );
  };

  const handleOnDelete = (param) => {
    console.log(param);

    let action = "Delete  ";
    let name = `${param.name}`;

    Notiflix.Confirm.show(
      "Are you sure?",
      action + name,
      "Yes",
      "No",

      function () {
        setIsLoading(true);
        const url = `${apiConfig.Codes}/${state.id}/codevalues/${param.key}`;
        let body = {
          method: "DELETE",
          session,
        };
        BOM.FetchReqAction(body, url, (err, res) => {
          if (err) {
            BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
            //STOP LOAD
            setIsLoading(false);
          } else {
            BOM.AlertMsg(cnt.SUCCESS, labelConfig.deleteCodeMsg);
            getCodeList();
            //STOP LOAD
            setIsLoading(false);
          }
        });
      },

      function () {
        // No button
      }
    );
  };

  return (
    <MainLayout isEnableRightSidebar={true} onDelete={handleOnDelete}>
      <TopContent
        pageTitle={labelConfig.detailCode}
        pageItems={staticConfig.detailCodeBreadcrumbItems}
      />

      <Card
        title={codeDetail.name}
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        {/* RENDER TABLE LIST HERE*/}
        <Spin spinning={isLoading} size="large">
          <Row>
            {BOM.HasPermission("CREATE_CODEVALUE") && (
              <AddCodeValue
                userData={userData}
                refreshList={getCodeList}
                currentCodeObj={state}
              />
            )}
          </Row>
          <Divider orientation="left" />
          <Table
            // rowSelection={{
            //   type: "radio",
            //   onChange: onSelectItemAction,
            // }}
            columns={columns}
            dataSource={codeValues}
            bordered
            pagination={{
              position: "bottomCentre",
              pageSize: tableCount,
            }}
          />
        </Spin>
      </Card>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };
export default connect(mapStateToProps, mapDispatchToProps)(DetailCode);

const EditCodeValue = (props) => {
  const { currentCodeObj, userData, refreshList, codeObj } = props;
  const { session } = userData;
  const { TextArea } = Input;
  const [useForm] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const showModal = () => {
    useForm.setFieldsValue({
      name: codeObj?.name,
      isActive: codeObj?.active,
      position: codeObj?.position,
      description: codeObj?.description,
    });
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onSubmitCodeValue = (formValues) => {
    const url = `${apiConfig.Codes}/${currentCodeObj.id}/codevalues/${codeObj.id}`;

    const body = {
      ...formValues,
      method: "PUT",
      session,
    };

    // console.log(body);
    // return;
    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, labelConfig.editCodeValueMsg);

        // close modal
        setIsModalOpen(false);

        //refresh the list
        refreshList();

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  return (
    <>
      <Tooltip title={"Edit Code Value"}>
        <Button
          type="primary"
          shape="round"
          className="of-primaryBtnColor"
          onClick={showModal}
        >
          <EditOutlined />
        </Button>
      </Tooltip>
      <Modal
        title="Edit Code Value"
        open={isModalOpen}
        okText="Save"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        // onOk={onSubmitCodeValue}
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form layout="vertical" form={useForm} onFinish={onSubmitCodeValue}>
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row>
            <Divider orientation="left">{labelConfig.generalInfo}</Divider>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.name}
                name="name"
                rules={BOM.fieldRules("name", true)}
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.name)}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.active}
                name="isActive"
                rules={BOM.fieldRules("active", true)}
              >
                <Select
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.active,
                    "select"
                  )}
                  options={staticConfig.trueOrFalseData}
                  showSearch
                  allowClear
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.position} name="position">
                <Input
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.position)}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.description}
                name="description"
                rules={BOM.fieldRules("description", true)}
              >
                <TextArea
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.description
                  )}
                />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </>
  );
};

const AddCodeValue = (props) => {
  const { currentCodeObj, userData, refreshList } = props;
  const { session } = userData;
  const { TextArea } = Input;
  const [useForm] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onSubmitCodeValue = (formValues) => {
    const url = `${apiConfig.Codes}/${currentCodeObj.id}/codevalues`;

    const body = {
      ...formValues,
      method: "POST",
      session,
    };

    // console.log(body);
    // return;
    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, labelConfig.newCodeValueMsg);

        // close modal
        setIsModalOpen(false);

        //refresh the list
        refreshList();

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  return (
    <>
      <Button
        type="primary"
        shape="round"
        className="of-primaryBtnColor"
        onClick={showModal}
      >
        <PlusCircleOutlined />
        &nbsp;{labelConfig.addCodeValue}
      </Button>
      <Modal
        title="Add Code Value"
        open={isModalOpen}
        okText="Save"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        // onOk={onSubmitCodeValue}
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form layout="vertical" form={useForm} onFinish={onSubmitCodeValue}>
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row>
            <Divider orientation="left">{labelConfig.generalInfo}</Divider>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.name}
                name="name"
                rules={BOM.fieldRules("name", true)}
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.name)}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.active}
                name="isActive"
                rules={BOM.fieldRules("active", true)}
              >
                <Select
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.active,
                    "select"
                  )}
                  options={staticConfig.trueOrFalseData}
                  showSearch
                  allowClear
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.position} name="position">
                <Input
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.position)}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.description}
                name="description"
                rules={BOM.fieldRules("description", true)}
              >
                <TextArea
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.description
                  )}
                />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </>
  );
};
